import { render } from "./SideMenus.vue?vue&type=template&id=767979ce&scoped=true"
import script from "./SideMenus.vue?vue&type=script&lang=js"
export * from "./SideMenus.vue?vue&type=script&lang=js"

import "./SideMenus.vue?vue&type=style&index=0&id=767979ce&lang=css&scoped=true"

import exportComponent from "D:\\project\\xiongmao-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767979ce"]])

export default __exports__